import { FileXIcon, SpinnerGapIcon } from "@phosphor-icons/react";

import SpinAnimation from "@gx/dls/animations/SpinAnimation";
import FlexItem from "@gx/dls/containers/FlexItem";
import FlexWrapper, {
  AlignItems,
  FlexDirection,
  JustifyContent,
} from "@gx/dls/containers/FlexWrapper";
import CodeEditor, { CodeEditorVariant } from "@gx/dls/editor/CodeEditor";
import Icon, { IconVariant } from "@gx/dls/icons/Icon";
import { SourceResource } from "@gx/ts-contracts/services/source/resources/source_pb";

import ErrorLayout from "@/layouts/ErrorLayout";

import { useEditSourceText } from "@/pages/sources/components/edit/tabs/content/text/hooks";

interface EditSourceContentTextProps {
  source: SourceResource;
}

const EditSourceContentText = ({ source }: EditSourceContentTextProps) => {
  const { textContent, isLoading, error } = useEditSourceText(source);

  if (isLoading) {
    return (
      <FlexWrapper
        minHeight={200}
        maxHeight={400}
        fillWidth
        alignItems={AlignItems.CENTER}
        justifyContent={JustifyContent.CENTER}
      >
        <SpinAnimation>
          <Icon component={SpinnerGapIcon} variant={IconVariant.PRIMARY} size={24} />
        </SpinAnimation>
      </FlexWrapper>
    );
  }

  if (error) {
    return (
      <FlexWrapper
        direction={FlexDirection.COLUMN}
        alignItems={AlignItems.CENTER}
        justifyContent={JustifyContent.CENTER}
        gap={8}
        fillWidth
        fillHeight
      >
        <ErrorLayout
          icon={FileXIcon}
          header="Error loading content"
          message="The text content you are looking for does not exist"
        />
      </FlexWrapper>
    );
  }

  return (
    <FlexItem fillWidth fillHeight>
      <CodeEditor
        content={textContent}
        variant={CodeEditorVariant.PRIMARY}
        borderRadius={5}
        padding="6px 4px"
        isReadOnly
        noLineNumbers
        noBorder
      />
    </FlexItem>
  );
};

export default EditSourceContentText;
